// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.item-selectable-article {
  margin: 8px 0;
  width: 100%;
  background: white;
  border: 0.5px solid #c0c0bf;
  border-radius: 2px;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1019607843);
  transition: border 200ms linear;
}
.item-selectable-article.selected {
  border-color: #000000;
  border-width: 1px;
}
.item-selectable-article.selected .select-button {
  background: var(--ion-color-tertiary);
  border-width: 0.5px;
  border-style: solid;
  border-color: #000000;
  box-shadow: 1px 1px 0px 1px;
}

.card-content {
  padding: 0;
  width: 100%;
}

.default-img {
  object-fit: contain !important;
}

.content-wrapper {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  gap: 16px;
  min-height: 90px;
}

.left-section {
  position: relative;
  flex-shrink: 0;
  width: 80px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.item-selectable-article-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.selected-icon {
  width: 18px;
  height: 21px;
  position: absolute;
  top: -15px;
  left: -3px;
  z-index: 10;
}

.middle-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
  min-width: 0;
}

.name {
  font-family: AppFontSemiBold;
  font-size: 16px;
  line-height: 128%;
  letter-spacing: 0;
  vertical-align: middle;
  text-transform: uppercase;
  word-break: break-word;
  display: flex;
  align-items: center;
  gap: 4px;
}

.option-price {
  font-family: AppFontSemiBold;
  font-size: 16px;
  line-height: 128%;
  letter-spacing: 0;
  vertical-align: middle;
  text-transform: uppercase;
  color: var(--color-grey);
}

.right-section {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.select-button {
  padding: 10px 24px;
  background: #e6e6e6;
  font-size: 13px;
  line-height: 100%;
  letter-spacing: -0.02em;
  color: #000;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 90px;
  height: 44px;
  white-space: nowrap;
  border-width: 0.5px;
  border-style: solid;
  border-color: transparent;
}
.select-button:active {
  background: rgba(217, 215, 210, 0.7647058824);
}

app-quantity-selector {
  filter: drop-shadow(0px 2px 10px rgba(0, 0, 0, 0.1));
}

@media (max-width: 576px) {
  .content-wrapper {
    gap: 12px;
    padding: 10px 12px;
  }
  .left-section {
    width: 60px;
    height: 50px;
  }
  .name {
    font-size: 14px;
  }
  .option-price {
    font-size: 13px;
  }
  .select-button {
    min-width: 75px;
    padding: 8px 16px;
    font-size: 13px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/item-selectable-article/item-selectable-article.component.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,WAAA;EACA,iBAAA;EACA,2BAAA;EACA,kBAAA;EACA,uDAAA;EAEA,+BAAA;AAAD;AAEC;EACC,qBAAA;EACA,iBAAA;AAAF;AAEE;EACC,qCAAA;EACA,mBAAA;EACA,mBAAA;EACA,qBAAA;EACA,2BAAA;AAAH;;AAKA;EACC,UAAA;EACA,WAAA;AAFD;;AAKA;EACC,8BAAA;AAFD;;AAKA;EACC,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;AAFD;;AAKA;EACC,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAFD;;AAKA;EACC,WAAA;EACA,YAAA;EACA,iBAAA;AAFD;;AAKA;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;AAFD;;AAKA;EACC,OAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,YAAA;AAFD;;AAKA;EACC,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EAEA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAHD;;AAMA;EACC,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EAEA,wBAAA;AAJD;;AAOA;EACC,cAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AAJD;;AAOA;EACC,kBAAA;EACA,mBAAA;EAEA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,WAAA;EAEA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EAEA,mBAAA;EACA,mBAAA;EACA,yBAAA;AAPD;AASC;EACC,6CAAA;AAPF;;AAWA;EACC,oDAAA;AARD;;AAYA;EACC;IACC,SAAA;IACA,kBAAA;EATA;EAYD;IACC,WAAA;IACA,YAAA;EAVA;EAaD;IACC,eAAA;EAXA;EAcD;IACC,eAAA;EAZA;EAeD;IACC,eAAA;IACA,iBAAA;IACA,eAAA;EAbA;AACF","sourcesContent":[".item-selectable-article {\n\tmargin: 8px 0;\n\twidth: 100%;\n\tbackground: white;\n\tborder: 0.5px solid #c0c0bf;\n\tborder-radius: 2px;\n\tbox-shadow: 0px 2px 8px 0px #0000001a;\n\n\ttransition: border 200ms linear;\n\n\t&.selected {\n\t\tborder-color: #000000;\n\t\tborder-width: 1px;\n\n\t\t.select-button {\n\t\t\tbackground: var(--ion-color-tertiary);\n\t\t\tborder-width: 0.5px;\n\t\t\tborder-style: solid;\n\t\t\tborder-color: #000000;\n\t\t\tbox-shadow: 1px 1px 0px 1px;\n\t\t}\n\t}\n}\n\n.card-content {\n\tpadding: 0;\n\twidth: 100%;\n}\n\n.default-img {\n\tobject-fit: contain !important;\n}\n\n.content-wrapper {\n\tdisplay: flex;\n\talign-items: center;\n\tpadding: 12px 16px;\n\tgap: 16px;\n\tmin-height: 90px;\n}\n\n.left-section {\n\tposition: relative;\n\tflex-shrink: 0;\n\twidth: 80px;\n\theight: 60px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n.item-selectable-article-image {\n\twidth: 100%;\n\theight: 100%;\n\tobject-fit: cover;\n}\n\n.selected-icon {\n\twidth: 18px;\n\theight: 21px;\n\tposition: absolute;\n\ttop: -15px;\n\tleft: -3px;\n\tz-index: 10;\n}\n\n.middle-section {\n\tflex: 1;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\tgap: 4px;\n\tmin-width: 0; // Allow text to wrap\n}\n\n.name {\n\tfont-family: AppFontSemiBold;\n\tfont-size: 16px;\n\tline-height: 128%;\n\tletter-spacing: 0;\n\tvertical-align: middle;\n\ttext-transform: uppercase;\n\n\tword-break: break-word;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 4px;\n}\n\n.option-price {\n\tfont-family: AppFontSemiBold;\n\tfont-size: 16px;\n\tline-height: 128%;\n\tletter-spacing: 0;\n\tvertical-align: middle;\n\ttext-transform: uppercase;\n\n\tcolor: var(--color-grey);\n}\n\n.right-section {\n\tflex-shrink: 0;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-end;\n}\n\n.select-button {\n\tpadding: 10px 24px;\n\tbackground: #e6e6e6;\n\n\tfont-size: 13px;\n\tline-height: 100%;\n\tletter-spacing: -0.02em;\n\tcolor: #000;\n\n\tborder: none;\n\tborder-radius: 4px;\n\tcursor: pointer;\n\ttransition: all 0.2s ease;\n\tmin-width: 90px;\n\theight: 44px;\n\twhite-space: nowrap;\n\n\tborder-width: 0.5px;\n\tborder-style: solid;\n\tborder-color: transparent;\n\n\t&:active {\n\t\tbackground: #d9d7d2c3;\n\t}\n}\n\napp-quantity-selector {\n\tfilter: drop-shadow(0px 2px 10px rgba(0, 0, 0, 0.1));\n}\n\n// Responsive adjustments for smaller screens\n@media (max-width: 576px) {\n\t.content-wrapper {\n\t\tgap: 12px;\n\t\tpadding: 10px 12px;\n\t}\n\n\t.left-section {\n\t\twidth: 60px;\n\t\theight: 50px;\n\t}\n\n\t.name {\n\t\tfont-size: 14px;\n\t}\n\n\t.option-price {\n\t\tfont-size: 13px;\n\t}\n\n\t.select-button {\n\t\tmin-width: 75px;\n\t\tpadding: 8px 16px;\n\t\tfont-size: 13px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
